import type { DataType } from '~/common/model/api/common';

/**
 * Prepare DataType.
 *
 * @param {DataType} type DataType.
 *
 * @returns {DataType} Prepared DataType.
 */
export function prepareDataType(type: DataType): DataType {
  if (type.name === 'table') {
    return {
      ...type,
      columns: Object.entries(type.columns ?? {}).map(([columnId, column]) => ({
        ...column,
        id: columnId,
      })),
    };
  }

  return type;
}
